import jwt from "jwt-decode";
import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Home from "../components/Layout/Home";
import AuthContext from "../context/Auth/authContext";
import { usePrivillage, useSocket } from "../hooks/";
//pages
import { NotFound403, NotFound404, NotFound500, SignIn } from "../pages";
import PrivateRoute from "./PrivateRoute";

export default function Routes({ component: Component, ...rest }) {
	const authContext = useContext(AuthContext);
	const { token } = authContext;
	let decoded;
	if (token) {
		decoded = jwt(token);
	}

	return (
		<Switch>
			   <Route
				   path="/"
				   exact
				   render={() =>
					   token ? (
						   decoded.dashboard_status ? (
							   <Redirect to="/dashboard" />
						   ) : (
							   <Redirect to="/task" />
						   )
					   ) : (
						   <SignIn />
					   )
				   }
			   />
			   <Route
				   path="/"
				   render={() =>
					   token ? <DashboardRoute /> : <Redirect to="/" />
				   }
			   />
		</Switch>
	);
}

export function DashboardRoute() {
	const { RouteTicketing } = usePrivillage();
	const { sendMessages } = useSocket("/notif", "trigger_notif");
	const authContext = useContext(AuthContext);
	const { token } = authContext;
	let decoded;
	if (token) {
		decoded = jwt(token);
	}

	   return (
		   <Home>
			   <Switch>
				   {decoded.dashboard_status ? (
					   <Redirect from="/" exact to="/dashboard" />
				   ) : (
					   <Redirect from="/" exact to="/task" />
				   )}
				   <Route path={RouteTicketing?.map((r) => r.path.replace('/ticketing', ''))}>
					   {RouteTicketing?.filter((r) => !r.render).map((r, i) => (
						   <PrivateRoute
							   exact={r.exact}
							   path={r.path.replace('/ticketing', '')}
							   key={i}
							   component={r.component}
						   />
					   ))}
					   {RouteTicketing?.filter((r) => r.render).map((r, i) => (
						   <Route
							   exact={r.exact}
							   path={r.path.replace('/ticketing', '')}
							   key={i}
							   render={(props) => (
								   <r.component
									   sendMessages={sendMessages}
									   location={props.location}
									   {...props}
								   />
							   )}
						   />
					   ))}
				   </Route>
				   <Route path="/404" component={NotFound404} />
				   <Route path="/500" component={NotFound500} />
				   <Route path="/403" component={NotFound403} />
				   <Redirect from="*" to="/404" />
			   </Switch>
		   </Home>
	   );
}
